
    <div class="app" fxLayoutAlign="start stretch" fxLayout="column" [class.primary-bg-lighter]="!authenticationService.authenticated()">
      <app-header fxFlex="nogrow" *ngIf="authenticationService.authenticated() && !isInLoginRoute()"></app-header>
      <div fxFlex *blockUI="'app-container'" fxLayoutAlign="start stretch" fxLayout="column" class="app-content">
        <router-outlet></router-outlet>
      </div>
      <app-footer fxFlex="nogrow" *ngIf="authenticationService.authenticated() && !isInLoginRoute()"></app-footer>
    </div>
    <app-messages></app-messages>
  